@if (isFetching) {
  <div class="chart-skeleton-container">
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{
        width: '320px',
        height: '28px',
        'margin-bottom': '10px',
        background: 'var(--skeleton-background)',
      }"
    ></ngx-skeleton-loader>
    <div class="legend-skeleton">
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        [theme]="{
          width: '120px',
          height: '20px',
          'margin-right': '16px',
          background: 'var(--skeleton-background)',
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        [theme]="{ width: '120px', height: '20px', background: 'var(--skeleton-background)' }"
      ></ngx-skeleton-loader>
    </div>
    <div class="chart-placeholder">
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        [theme]="{
          width: '100%',
          height: '270px',
          'border-radius': '8px',
          background: 'var(--skeleton-background)',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
}
@if (!isFetching && errorFetching) {
  <div class="section-error">
    <mat-icon>error_outline</mat-icon>
    <span>Failed to load 30-day chart data</span>
    <button class="retry-button" (click)="retry()">Retry</button>
  </div>
}
@if (!isFetching && !errorFetching) {
  <mat-card class="chart-card">
    <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="'line'"> </canvas>
  </mat-card>
}
